import React from "react";

import {
  Show,
  TextField,
  EditButton,
  TopToolbar,
  SimpleShowLayout,
} from "react-admin";

import { BackButton } from "../../../components/common/BackButton";

const SetupShow = (props) => (
  <Show {...props} actions={<SetupShowActions />}>
    <SimpleShowLayout>
      <TextField source="firstName" />
      <TextField source="lastName" />
      <TextField source="status" />
      <TextField source="cognitoId" />

      <TextField source="setupData" />
      <TextField source="submitDate" />
      <TextField source="approvalDate" />
      <TextField source="approvedBy" />
    </SimpleShowLayout>
  </Show>
);

const SetupShowActions = ({ basePath, data }) => (
  <TopToolbar>
    <EditButton basePath={basePath} record={data} />
    <BackButton basePath={basePath} />
  </TopToolbar>
);

export default SetupShow;
